import React, { useState, useEffect, Fragment, useRef} from 'react';
import { Button, Modal, Form, InputGroup, FormCheck, Badge } from 'react-bootstrap';
//import DataTable from 'react-data-table-component';
import DataTable from 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
import './questTable.css';
import axios from 'axios';
import { useLanguage } from '../../../i18n/LanguageContext';
import apiUrl from '../../../config/api';
import QuestionPreviewModal from './QuestionPreviewModal';

const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const isClosedQuestionMissingCorrectAnswer = (question) => (
  question?.questionType === 'closed'
  && Array.isArray(question.answers)
  && !question.answers.some((answer) => answer.isCorrect)
);

const isOpenQuestionMissingAnswer = (question) => (
  question?.questionType === 'open'
  && (
    !Array.isArray(question.answers)
    || !question.answers.some((answer) => String(answer?.text || '').trim())
  )
);

const QuestionsTable = ({ selectedSubject, questions, setSubjects, setQuestions}) => {
  const { t } = useLanguage();
  const text = t.subjectsPage;
 
  const edit =    `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z" fill="currentColor"></path><path d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z" fill="currentColor"></path><path opacity="0.4" d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z" fill="currentColor"></path>
                  </svg>`

  const del =     `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.4" d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z" fill="currentColor"></path><path d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z" fill="currentColor"></path>
                  </svg>`

  const preview = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M21.25 12C21.25 12 17.8 5.75 12 5.75C6.2 5.75 2.75 12 2.75 12C2.75 12 6.2 18.25 12 18.25C17.8 18.25 21.25 12 21.25 12Z" fill="currentColor"></path>
                    <path d="M12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25Z" fill="currentColor"></path>
                  </svg>`

  const add3 = <svg width="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path opacity="0.4" d="M16.6667 2H7.33333C3.92889 2 2 3.92889 2 7.33333V16.6667C2 20.0622 3.92 22 7.33333 22H16.6667C20.0711 22 22 20.0622 22 16.6667V7.33333C22 3.92889 20.0711 2 16.6667 2Z" fill="currentColor"></path><path d="M15.3205 12.7083H12.7495V15.257C12.7495 15.6673 12.4139 16 12 16C11.5861 16 11.2505 15.6673 11.2505 15.257V12.7083H8.67955C8.29342 12.6687 8 12.3461 8 11.9613C8 11.5765 8.29342 11.2539 8.67955 11.2143H11.2424V8.67365C11.2824 8.29088 11.6078 8 11.996 8C12.3842 8 12.7095 8.29088 12.7495 8.67365V11.2143H15.3205C15.7066 11.2539 16 11.5765 16 11.9613C16 12.3461 15.7066 12.6687 15.3205 12.7083Z" fill="currentColor"></path>
  </svg>

  const del3 = <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z" fill="currentColor"></path><path d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z" fill="currentColor"></path>
  </svg>

  const tableRef = useRef(null);
  const questionTypeFilterRef = useRef('all');
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [previewState, setPreviewState] = useState(null);
  const [selectedPassage, setSelectedPassage] = useState(null);

  // Modal Question Del
  const [showModalQuestionDel, setShowModalQuestionDel] = useState(false);

  const handleCloseQuestionDel = () => {
    setSelectedQuestion(null);
    setShowModalQuestionDel(false);
  };

  const handleShowQuestionDel = () => {
    setShowModalQuestionDel(true)
  };


  const initializeTable = () => {
    // Controlla se la tabella esiste già
    if (tableRef.current) {
      const tableElement = document.querySelector('#questionsTable');

      if (tableElement && tableRef.current.clickHandler) {
        tableElement.removeEventListener('click', tableRef.current.clickHandler);
      }

      tableRef.current.clear().destroy(); // Distruggi la tabella esistente se già esiste
      tableRef.current = null;
    }

    // Pre-processare le domande per aggiungere l'ID numerico
    const preprocessedQuestions = questions.map((question, index) => {
      return {
        ...question,
        numericalId: index + 1, // Aggiunge un ID numerico basato sull'ordine delle domande
        answers: question.answers.map(answer => answer.text), // Estrai il testo delle risposte
        correct: question.answers.filter(answer => answer.isCorrect).map(answer => answer.text).join(' | '), // Risposte corrette concatenate
      };
    });

    // Definisci le colonne dinamicamente
    const TableColumns = [
      { title: '#', data: 'numericalId' }, // Mostra il numericalId come ID
      {
        title: text.table.question,
        data: 'questionText',
        render: function (data, type, row) {
          const questionText = escapeHtml(data);

          if (!row.hasPassage && !row.passageText) {
            return questionText;
          }

          return `
            <div>${questionText}</div>
            <button type="button" class="btn btn-soft-info btn-sm mt-2 passage-btn" data-id="${row._id}">
              ${escapeHtml(text.readPassage(row.passageNumber))}
            </button>
          `;
        },
      },
      {
        title: text.table.answers, data: 'answers', render: function (data) {
          return data.join(" | "); // Unisce tutte le risposte con il separatore ' | '
        }
      },
      { title: text.table.correct, data: 'correct' },
      {
        title: text.table.typeFilterLabel,
        data: 'questionType',
        visible: false,
        searchable: true,
      },
      {
        title: text.table.actions, // Colonna per le azioni
        data: null, // Lasciamo vuoto perché vogliamo gestire i bottoni
        orderable: false, // Disabilita il sorting su questa colonna
        render: function (data, type, row) {
          return `
              <div class="questions-table-actions">
                <button type="button" class="btn btn-soft-info btn-sm preview-btn" title="${escapeHtml(text.previewQuestion)}" aria-label="${escapeHtml(text.previewQuestion)}" data-id="${row._id}">${preview}</button>
                <button type="button" class="btn btn-primary btn-sm edit-btn" data-id="${row._id}">${edit}</button>
                <button type="button" class="btn btn-danger btn-sm delete-btn" data-id="${row._id}">${del}</button>
              </div>
            `;
        }
      }
    ];

    tableRef.current = new DataTable('#questionsTable', {
      columns: TableColumns,
      data: preprocessedQuestions,
      destroy: true,
      deferRender: true,
      pageLength: 25,
      autoWidth: false,
      scrollX: true,
      language: {
        search: text.table.search,
        lengthMenu: text.table.lengthMenu,
        info: text.table.info,
        infoFiltered: '',
        infoEmpty: text.table.infoEmpty,
        zeroRecords: text.table.zeroRecords,
        emptyTable: text.table.emptyTable,
        paginate: {
          previous: text.table.paginatePrevious,
          next: text.table.paginateNext,
        },
      },
    });
    const questionTypeColumnIndex = 4;

    if (questionTypeFilterRef.current !== 'all') {
      tableRef.current
        .column(questionTypeColumnIndex)
        .search(`^${questionTypeFilterRef.current}$`, true, false)
        .draw();
    }

    const wrapperElement = document.querySelector('#questionsTable_wrapper');
    const lengthContainer = wrapperElement?.querySelector('.dt-length, .dataTables_length');

    if (lengthContainer && !lengthContainer.querySelector('.questions-type-filter')) {
      const filterContainer = document.createElement('div');
      const selectId = 'questionsTableTypeFilter';

      filterContainer.className = 'questions-type-filter';
      filterContainer.innerHTML = `
        <label class="questions-type-filter-label" for="${selectId}">${escapeHtml(text.table.typeFilterLabel)}</label>
        <select id="${selectId}" class="form-select form-select-sm questions-type-filter-select" aria-label="${escapeHtml(text.table.typeFilterLabel)}">
          <option value="all">${escapeHtml(text.table.typeFilterAll)}</option>
          <option value="closed">${escapeHtml(text.table.typeFilterClosed)}</option>
          <option value="open">${escapeHtml(text.table.typeFilterOpen)}</option>
        </select>
      `;

      const filterSelect = filterContainer.querySelector('select');
      filterSelect.value = questionTypeFilterRef.current;
      filterSelect.addEventListener('change', (event) => {
        questionTypeFilterRef.current = event.target.value;
        tableRef.current
          ?.column(questionTypeColumnIndex)
          .search(event.target.value === 'all' ? '' : `^${event.target.value}$`, true, false)
          .draw();
      });
      lengthContainer.appendChild(filterContainer);
    }

    const tableElement = document.querySelector('#questionsTable');
    const handleTableClick = (event) => {
      const previewButton = event.target.closest('.preview-btn');
      const editButton = event.target.closest('.edit-btn');
      const deleteButton = event.target.closest('.delete-btn');
      const passageButton = event.target.closest('.passage-btn');

      if (previewButton) {
        handleShowPreviewQuestion(previewButton.dataset.id, event);
        return;
      }

      if (editButton) {
        handleShowEditQuestion(editButton.dataset.id, event);
        return;
      }

      if (deleteButton) {
        handleDeleteQuestion(deleteButton.dataset.id, event);
        return;
      }

      if (passageButton) {
        handleShowPassage(passageButton.dataset.id, event);
      }
    };

    if (tableElement) {
      tableElement.addEventListener('click', handleTableClick);
      tableRef.current.clickHandler = handleTableClick;
    }
  }

  useEffect(() => {
    initializeTable();

    return () => {
      const tableElement = document.querySelector('#questionsTable');

      if (tableElement && tableRef.current?.clickHandler) {
        tableElement.removeEventListener('click', tableRef.current.clickHandler);
      }

      if (tableRef.current) {
        tableRef.current.clear().destroy();
        tableRef.current = null;
      }
    };
  }, [questions, text]);
    
  // Funzione per gestire l'editing di una domanda
  const handleEditQuestion = (questionId, event) => {
      event.preventDefault();
      // Qui puoi gestire la logica per modificare la domanda
      // Ad esempio, aprire un modal con un form per modificare la domanda
      alert(`Edit question with id: ${questionId}`);
      // Implementa la tua logica qui
  };

  // Funzione per gestire l'editing di una domanda
  const handleDeleteQuestion = (questionId, event) => {
    event.preventDefault();
    // Qui puoi gestire la logica per modificare la domanda
    // Ad esempio, aprire un modal con un form per modificare la domanda
    //alert(`del question with id: ${questionId}`);
    // Trova la domanda da eliminare usando l'ID
    const questionToDelete = questions.find(q => q._id === questionId);
    setSelectedQuestion(questionToDelete); // Imposta la domanda selezionata
    //alert(JSON.stringify(questionToDelete));
    handleShowQuestionDel();
    // Implementa la tua logica qui
};

  const handleShowPassage = async (questionId, event) => {
    event.preventDefault();
    const questionWithPassage = questions.find(q => q._id === questionId);

    if (!questionWithPassage) {
      return;
    }

    if (questionWithPassage.passageText) {
      setSelectedPassage(questionWithPassage);
      return;
    }

    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await axios.post(
        `${apiUrl}/getQuestionPassage`,
        { questionId },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      setSelectedPassage({
        ...questionWithPassage,
        passageNumber: response.data.passageNumber,
        passageText: response.data.passageText,
      });
    } catch (error) {
      console.error('Errore durante il recupero del brano', error);
      alert(text.validation?.genericError || 'Errore durante il recupero del brano.');
    }
  };

  const getAppliedFilteredQuestions = () => {
    const questionById = new Map(
      (Array.isArray(questions) ? questions : []).map((question) => [String(question._id), question])
    );
    const appliedRows = tableRef.current?.rows({ search: 'applied', order: 'applied' })?.data()?.toArray?.() || [];
    const filteredQuestions = appliedRows
      .map((row) => questionById.get(String(row?._id)))
      .filter(Boolean);

    return filteredQuestions.length ? filteredQuestions : (Array.isArray(questions) ? questions : []);
  };

  const handleShowPreviewQuestion = (questionId, event) => {
    event.preventDefault();
    event.target.closest('button')?.blur();
    const filteredQuestions = getAppliedFilteredQuestions();
    const currentIndex = Math.max(0, filteredQuestions.findIndex((question) => question._id === questionId));

    if (!filteredQuestions.length) {
      alert(text.noFilteredQuestionsToPreview);
      return;
    }

    setPreviewState({
      mode: 'list',
      questions: filteredQuestions,
      currentIndex,
    });
  };

  const handleClosePreviewQuestion = () => {
    setPreviewState(null);
  };

  const handleNavigatePreviewQuestion = (direction) => {
    setPreviewState((currentState) => {
      if (!currentState?.questions?.length) {
        return currentState;
      }

      const maxIndex = currentState.questions.length - 1;
      const nextIndex = Math.min(maxIndex, Math.max(0, currentState.currentIndex + direction));

      return {
        ...currentState,
        currentIndex: nextIndex,
      };
    });
  };

  const handlePreviewQuestionUpdated = (updatedQuestion) => {
    setPreviewState((currentState) => (
      currentState
        ? {
          ...currentState,
          questions: currentState.questions.map((question) => (
            question._id === updatedQuestion._id ? { ...question, ...updatedQuestion } : question
          )),
        }
        : currentState
    ));
    setQuestions((prevQuestions) => (
      Array.isArray(prevQuestions)
        ? prevQuestions.map((question) => (
          question._id === updatedQuestion._id ? { ...question, ...updatedQuestion } : question
        ))
        : prevQuestions
    ));
  };

  const previewQuestions = previewState?.questions || [];
  const previewQuestion = previewQuestions[previewState?.currentIndex || 0] || null;
  const isPreviewListMode = previewState?.mode === 'list';

const handleConfirmQuestionDelete = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (selectedQuestion) {
    try {
      const response = await axios.post(`${apiUrl}/delQuestion`, {questionId: selectedQuestion._id}, {headers: {
          'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
          'Accept' : 'application/json',
          'Content-Type': 'application/json'}}
      )

      if (response.status === 201) {
        // Rimuovi la domanda dall'array e aggiorna lo stato
        setQuestions((prevQuestions) => 
          prevQuestions.filter(q => q._id !== selectedQuestion._id)
        );
        // Aggiorna lo stato delle materie
        setSubjects((prevSubjects) => {
          // Aggiorna i conteggi delle domande per la materia specificata
          const updatedSubjects = prevSubjects.map((subject) => {
            if (subject._id === selectedSubject._id) {
              return {
                ...subject,
                totalQuestions: subject.totalQuestions - 1, // Decrementa il totale delle domande
                openQuestions: subject.openQuestions - (selectedQuestion.questionType === 'open' ? 1 : 0),
                closedQuestions: subject.closedQuestions - (selectedQuestion.questionType === 'closed' ? 1 : 0),
                missingCorrectAnswers: Math.max(0, (subject.missingCorrectAnswers || 0) - (isClosedQuestionMissingCorrectAnswer(selectedQuestion) ? 1 : 0)),
                missingOpenAnswers: Math.max(0, (subject.missingOpenAnswers || 0) - (isOpenQuestionMissingAnswer(selectedQuestion) ? 1 : 0)),
              };
            }
            return subject; // Restituisci le altre materie non modificate
          });

          // Ora ordiniamo alfabeticamente per nome le materie aggiornate
          return updatedSubjects.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { caseFirst: 'upper' })
          );
        });
        setShowModalQuestionDel(false); // Chiudi la modale
        setSelectedQuestion(null); // Resetta la domanda selezionata
      }
    } catch (error) {
      console.error('Errore durante la modifica della domanda', error);
    }
  }
};

  // Modal Question Edit
  
 

  const [showModalEditQuestion, setShowEditQuestion] = useState(false);
    const handleCloseEditQuestion = () => {
        clearParamsEditQuestionContext();
        setShowEditQuestion(false);
    };

    const handleShowEditQuestion = (questionId, event) => { 
      event.preventDefault();
      setSelectedQuestion(() => {
        return questions.find(q => q._id === questionId)
      });
      setShowEditQuestion(true);
    };

    useEffect(() => {
      if (questionToEditRef2.current && showModalEditQuestion) {
        questionToEditRef2.current.value = selectedQuestion.questionText;
        isOpenedEditQuestionRef.current.checked = selectedQuestion.questionType === "open" ? true : false;
        isMultipleEditRef.current.checked = selectedQuestion.answerType === "multiple" ? true : false;
        setOpenedEditQuestion(selectedQuestion.questionType === "open" ? true : false);
        setIsMultipleEdit(selectedQuestion.answerType === "multiple" ? true : false);
        setAnswersToEdit(selectedQuestion.answers);
      }
    }, [showModalEditQuestion]);

    //Fixing Params Form
    const [questionToEdit, setQuestionToEdit] = useState('');
    const questionToEditRef2 = useRef(null);

    const [isOpenedEditQuestion, setOpenedEditQuestion] = useState(false);
    const isOpenedEditQuestionRef = useRef(null);
    
    const [isMultipleEdit, setIsMultipleEdit] = useState(false);
    const isMultipleEditRef = useRef(null);

    const [answersToEdit, setAnswersToEdit] = useState([{ text: '', isCorrect: false }, { text: '', isCorrect: false }]);
    const answersToEditRef = useRef(null);

    

    //Clear Params Form
    const clearParamsEditQuestionContext = () => {
        setQuestionToEdit('');
        setOpenedEditQuestion(false);
        setIsMultipleEdit(false);
        setAnswersToEdit([{ text: '', isCorrect: false }, { text: '', isCorrect: false }]);
    }

    const clearParamsQuestionAnswersRef= () => {
        questionToEditRef2.current.value='';
    }

    // Effetto che viene eseguito dopo che isOpenedQuestion e/o isMultiple cambia
    useEffect(() => {
      // Questo effetto verrà eseguito subito dopo che lo stato isOpenedQuestion è stato aggiornato
      if(isOpenedEditQuestion && isMultipleEdit){
          isMultipleEditRef.current.checked = !isMultipleEdit;
          setIsMultipleEdit(!isMultipleEdit);
      }
      
      
  }, [isOpenedEditQuestion, isMultipleEdit]);

  // Effetto che viene eseguito dopo che isOpenedQuestion e/o isMultiple cambia
  useEffect(() => {
      // Questo effetto verrà eseguito subito dopo che lo stato isOpenedQuestion è stato aggiornato
      if(isOpenedEditQuestion && isMultipleEdit){
          
          isMultipleEditRef.current.checked = !isMultipleEdit;
          setIsMultipleEdit(!isMultipleEdit);
      }

      if(!isOpenedEditQuestion){
          setAnswersToEdit([{text: '', isCorrect: false }, {text: '', isCorrect: false }])
      } else {
          setAnswersToEdit([{text: '', isCorrect: true }])
      }
      
  }, [isOpenedEditQuestion]);

  // Effetto che viene eseguito dopo che isOpenedQuestion e/o isMultiple cambia
  useEffect(() => {
      // Deseleziona tutte le risposte quando si passa a 'singola'
      if (!isOpenedEditQuestion && !isMultipleEdit) {
          setAnswersToEdit(prevAnswers =>
          prevAnswers.map(answer => ({
              ...answer,
              isCorrect: false // Deseleziona tutte le risposte
          }))
          );
      }
  }, [isMultipleEdit]);

  const handleSetEditAnswers = (index, field, value) => {
      const updatedAnswers = [...answersToEdit];
      updatedAnswers[index][field] = value;
      setAnswersToEdit(updatedAnswers);
  };

  // Gestione della selezione delle risposte corrette
  const handleSetCheckAnswers = (index) => {
      //alert("sono qui");

      if (isMultipleEdit) {
          // Se è multipla, permette la selezione di più risposte corrette
          setAnswersToEdit((prevAnswers) =>
            prevAnswers.map((answer, idx) =>
              idx === index ? { ...answer, isCorrect: !answer.isCorrect } : answer
            )
          );
        } else {
          // Se è singola, deseleziona tutte le altre risposte e seleziona solo quella corrente
          setAnswersToEdit((prevAnswers) =>
            prevAnswers.map((answer, idx) => ({
              ...answer,
              isCorrect: idx === index // Seleziona solo quella corrente
            }))
          );
        }
  };

  const handleAddFieldEditAnswer = () => {
      setAnswersToEdit([...answersToEdit, { text: '', isCorrect: false }]);
  };

  // Funzione per eliminare una risposta
  const handleDelFieldEditAnswer = (index) => {
      if (answersToEdit.length > 2) {
          setAnswersToEdit(answersToEdit.slice(0, -1));
      }
  };

  const handleSubmitEditQuestion = async (e) => {
      e.preventDefault();
      try {
        // 1. Raccogliere i dati dal form
        const questionData = {
          questionText: questionToEditRef2.current.value, // Assumi che 'questionToAdd' sia lo stato della tua textarea per la domanda
          questionType: isOpenedEditQuestion ? 'open' : 'closed', // Assumi che 'isOpenedQuestion' sia lo stato dello switch per il tipo di domanda
          answerType: isMultipleEdit ? 'multiple' : 'single', // Assumi che 'isMultiple' sia lo stato per risposte multiple
          answers: answersToEdit, // Assumi che 'answersToAdd' sia uno stato che contiene le risposte [{ text: 'Risposta 1', isCorrect: false }, ...]
        };
        
        const  isCorrectAnswerSelected = answersToEdit.some(answer => answer.isCorrect);

        if(!isCorrectAnswerSelected){
            alert(text.validation.noCorrectAnswer);
        }

        // 2. Validare i dati della domanda (facoltativo, puoi anche fare la validazione nel backend)
        if (questionData.questionType === 'closed') {
          if (questionData.answers.length < 2) {
            alert(text.validation.closedNeedsTwoAnswers);
            return;
          }
    
          const hasCorrectAnswer = questionData.answers.some(answer => answer.isCorrect);
          if (!hasCorrectAnswer) {
            alert(text.validation.selectCorrectAnswer);
            return;
          }
        }
    
        // 3. Inviare i dati al backend
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const response = await axios.post(`${apiUrl}/editQuestion`, {
            questionId: selectedQuestion._id, 
            questionData: questionData,
          }, 
          {
            headers: {
                'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        });
    
        // 4. Gestire la risposta del server
        if (response.status === 201) {
          alert(text.validation.editQuestionSuccess);
          //console.log(response.data);
          const previousQuestion = selectedQuestion;
          const updatedQuestion = response.data;
          // Aggiorna tabella
          setQuestions(prevQuestions => {
            return prevQuestions.map(question =>
              question._id === updatedQuestion._id ? updatedQuestion : question
            );
          });
          setSubjects((prevSubjects) => prevSubjects.map((subject) => {
            if (subject._id !== selectedSubject._id) {
              return subject;
            }

            return {
              ...subject,
              openQuestions: Math.max(0, subject.openQuestions - (previousQuestion.questionType === 'open' ? 1 : 0) + (updatedQuestion.questionType === 'open' ? 1 : 0)),
              closedQuestions: Math.max(0, subject.closedQuestions - (previousQuestion.questionType === 'closed' ? 1 : 0) + (updatedQuestion.questionType === 'closed' ? 1 : 0)),
              missingCorrectAnswers: Math.max(0, (subject.missingCorrectAnswers || 0) - (isClosedQuestionMissingCorrectAnswer(previousQuestion) ? 1 : 0) + (isClosedQuestionMissingCorrectAnswer(updatedQuestion) ? 1 : 0)),
              missingOpenAnswers: Math.max(0, (subject.missingOpenAnswers || 0) - (isOpenQuestionMissingAnswer(previousQuestion) ? 1 : 0) + (isOpenQuestionMissingAnswer(updatedQuestion) ? 1 : 0)),
            };
          }));
          
        } else {
          alert(text.validation.editQuestionError);
        }

        handleCloseEditQuestion();

      } catch (error) {
        console.error('Errore durante la modifica della domanda: ', error);
        alert(text.validation.editQuestionRetry);
      }
  }

  return (
    <Fragment>
      <div className="table-view quiz-questions-table table-space">
        <table
          id="questionsTable"
          className="data-tables table custom-table movie_table"
          data-toggle="data-table">
        </table>
      </div> 

      <QuestionPreviewModal
        show={!!previewQuestion}
        question={previewQuestion}
        isListMode={isPreviewListMode}
        currentIndex={previewState?.currentIndex || 0}
        totalQuestions={previewQuestions.length}
        subjectName={selectedSubject?.name || ''}
        onHide={handleClosePreviewQuestion}
        onPrevious={() => handleNavigatePreviewQuestion(-1)}
        onNext={() => handleNavigatePreviewQuestion(1)}
        onShowPassage={handleShowPassage}
        onQuestionUpdated={handlePreviewQuestionUpdated}
      />

      {/* <!-- Edit Question & Answer Modal --> */}
      {showModalEditQuestion && selectedSubject && (
        <Modal className="modal-question-bg" show={showModalEditQuestion} onHide={handleCloseEditQuestion} centered>
          <Form onSubmit={(e) => handleSubmitEditQuestion(e)}>
            <Modal.Header closeButton>
              <div>
                <h5>{text.editQuestionAnswers}</h5>
                <small className="text-muted ">
                  {selectedSubject.name}
                </small>
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3">
                <Form.Group className="form-group">
                  <span className="input-group-text">{text.question}</span>
                  <InputGroup>
                    <textarea ref={questionToEditRef2} rows={3} className="form-control" onChange={(e) => setQuestionToEdit(e.target.value)} aria-label={text.question} required></textarea>
                  </InputGroup>
                </Form.Group>

                <div className="text-center mb-1">{text.questionAnswerType}</div>
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <Badge bg="secondary me-2">{text.closed}</Badge>
                  <Form.Check className="form-switch">
                    <FormCheck.Input ref={isOpenedEditQuestionRef} className="form-check-input-question-type primary" onChange={(e) => setOpenedEditQuestion(!isOpenedEditQuestion)} type="checkbox" id="flexSwitchCheckChecked" />
                  </Form.Check>
                  <Badge bg="primary" className='me-3'>{text.open}</Badge>
                  <Badge bg="secondary" className='me-2'>{text.single}</Badge>
                  <Form.Check className="form-switch">
                    <FormCheck.Input ref={isMultipleEditRef} className="form-check-input-question-type primary" onChange={(e) => setIsMultipleEdit(!isMultipleEdit)} type="checkbox" id="flexSwitchCheckChecked" />
                  </Form.Check>
                  <Badge bg="primary" className=''>{text.multiple}</Badge>
                </div>
                {answersToEdit.map((answer, index) => (

                  (isOpenedEditQuestion && (


                    <Form.Group key={index} className="form-group">
                      <InputGroup>
                        <span className="input-group-text">
                          {text.correctAnswer}
                        </span>
                        <textarea rows={3} onChange={(e) => handleSetEditAnswers(index, 'text', e.target.value)} className="form-control" aria-label={text.correctAnswer} required></textarea>
                      </InputGroup>
                    </Form.Group>
                  )) ||

                  (!isOpenedEditQuestion && (


                    <Form.Group key={index} className="form-group">
                      <InputGroup>
                        <span className={`input-group-text cursor-click ${answersToEdit[index].isCorrect ? 'bg-success text-white' : ''}`} onClick={(e) => handleSetCheckAnswers(index)}>
                          {text.answer(index + 1)}
                        </span>
                        <textarea value={answersToEdit[index].text} rows={1} onChange={(e) => handleSetEditAnswers(index, 'text', e.target.value)} className="form-control" aria-label={text.answer(index + 1)} required></textarea>
                      </InputGroup>
                    </Form.Group>
                  ))
                ))}
                {!isOpenedEditQuestion && (
                  <div className="d-flex align-items-center justify-content-center">
                    <Button className="p-1" variant="soft-gray" size="sm" onClick={handleAddFieldEditAnswer} >
                      {add3}
                    </Button>
                    {answersToEdit.length > 2 && (
                      <Button className="p-1 ms-2" variant="soft-danger" size="sm" onClick={handleDelFieldEditAnswer} >
                        {del3}
                      </Button>

                    )}
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="primary">{text.edit}</Button>
              <Button variant="soft-danger" onClick={handleCloseEditQuestion}>{text.close}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
     
      {/* <!-- Question Del Modal --> */}
      {showModalQuestionDel && (<Modal className="modal-theme-bg" show={showModalQuestionDel} onHide={handleCloseQuestionDel} centered>
        <Modal.Header closeButton>
          <Modal.Title as="h5">{text.confirmDeletion}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <p>{text.deleteQuestionConfirm(selectedQuestion.questionText)}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="success" onClick={handleConfirmQuestionDelete}>{text.yesDelete}</Button>
          <Button variant="soft-danger" onClick={handleCloseQuestionDel}>{text.abort}</Button>
        </Modal.Footer>
      </Modal>
      )}
      {selectedPassage && (
        <Modal className="modal-theme-bg" show={!!selectedPassage} onHide={() => setSelectedPassage(null)} centered scrollable>
          <Modal.Header closeButton>
            <Modal.Title as="h5">{text.passageTitle(selectedPassage.passageNumber)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-0">{selectedPassage.passageText}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="soft-danger" onClick={() => setSelectedPassage(null)}>{text.close}</Button>
          </Modal.Footer>
        </Modal>
      )}
    </Fragment>
    
  );
};

export default QuestionsTable;
